import $ from 'jquery';
import Swiper from 'swiper/bundle';

export default class FundingSteps {

    constructor() {
        this.settings = {
            $swiper: $('.js-funding-steps-swiper')
        };
        this.bindUIActions();
    }

    bindUIActions() {
        if (this.settings.$swiper.length) {
            new Swiper('.js-funding-steps-swiper', {
                slidesPerView: 2,
                grabCursor: true,
                keyboard: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-progress-bar',
                    type: 'progressbar',
                    clickable: true,
                },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
                breakpoints: {
                    1024: {
                      slidesPerView: 4,
                    },
                },
                on: {
                    progress: function (swiper, progress) {
                        let roundedProgress;

                        if (window.matchMedia('(max-width: 640px)').matches) {
                            roundedProgress = Math.floor(progress * 10) / 10;
                        } else if (window.matchMedia('(max-width: 1024px)').matches) {
                            roundedProgress = Math.floor(progress * 9.8) / 10;
                        } else {
                            roundedProgress = Math.floor(progress * 9) / 10;
                        }

                        $('.js-slider-index-container').each(function(index) {
                            if (roundedProgress >= index / swiper.slides.length) {
                                $(this).css('background-color', '#E1102D');
                            } else {
                                $(this).css('background-color', '');
                            }
                        });
                    },
                },
            });
        }
    }

};

new FundingSteps();